import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useModal } from "contexts/modalContext";
import { Button } from "components/button";

// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  const { t } = useTranslation();
  const tBase = "pages.unprotected.contracts.index";
  const tr = (key) => t(`${tBase}.${key}`);

  const params = useParams();
  const { setShow } = useModal();

  const [termsChecked, setTermsChecked] = useState(false);
  const [signed, setSigned] = useState("");

  const contract = useQuery("contract", async () => {
    return await axios
      .get(
        `${process.env.REACT_APP_API}/api/v1/consumer/contracts?string=${params.string}`
      )
      .then((res) => res.data);
  });

  const logo = useQuery("logo", async () => {
    return await axios
      .get(
        `${process.env.REACT_APP_API}/api/v1/consumer/contracts/logo?string=${params.string}`
      )
      .then((res) => res.data);
  });

  const signContract = useMutation(
    async (payload) => {
      return await axios
        .post(
          `${process.env.REACT_APP_API}/api/v1/consumer/contracts?string=${params.string}`,
          payload
        )
        .then((res) => res.data);
    },
    {
      onSuccess: (_data, variables) => {
        setSigned(variables.action);
      },
    }
  );

  const Logo = () => {
    return (
      <div style={{ margin: "auto" }}>
        <Image src={`data:image/png;base64,${logo.data}`} alt="logo" />
      </div>
    );
  };

  const message = (message) => {
    return (
      <div className="flex flex-col">
        <Content>
          <h1>
            {message}
          </h1>
        </Content>
      </div>
    )
  };

  const DeclineModal = () => {
    const [note, setNote] = useState("");
    
    return (
      <div>
        <div>
          <div className="mt-2">{tr("Please provide a reason for declining the contract")}</div>
          <textarea
            className="w-full h-32 p-2 border border-gray-300 rounded"
            value={note}
            onChange={(e) => {

              setNote(e.target.value);
            }}
          />
        </div>
        <div className="flex items-center space-x-4 justify-end mt-6">
          <Button onClick={() => setShow()}>
            {tr("Cancel")}
          </Button>
          <Button
            primary
            onClick={() => {
              signContract.mutate({ action: "decline", note: note });
              setShow();
            }}
          >
            {tr("Submit")}
          </Button>
        </div>
      </div>
    );
  };
  
  const decline = () => {
    setShow({
      label: tr("Decline Note"),
      component: <DeclineModal />
    });
  };


  if (contract.isError) {
    return message(tr("Invalid contract key please contact the business directly"));
  } else if (contract.isLoading) {
    return message(tr("Loading..."));
  } else if (signed === "approve" || contract.data.status == 45) {
    return message(tr("The contract has been approved. You may now close this page."));
  } else if (signed === "decline" || contract.data.status == 47) {
    return message(tr("The contract has been declined. You may close this page."));
  } else {
    return (
      <div className="flex flex-col">
        <Content style={{ marginBottom: "20px" }}>
          <Logo />
          <div
            style={{
              margin: "20px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <h1
              style={{
                width: "100%",
                marginBottom: "20px",
              }}
            >
              {" "}
              {tr("Please read and agree to the Terms and Conditions below")}:
            </h1>
            {contract?.data.terms.description ? (
              <>
                <h3>{tr("Description")}:</h3>
                <div>
                  {contract?.data.terms.description.split(/\n/g).map((line, index) => (
                    <p key={index}>
                      {line === "" ? <br /> : line} {/* Keeps extra empty lines */}
                    </p>
                  ))}
                </div>
              </>
            ) : null}
          </div>
          <div
            style={{
              height: "20%",
              width: "100%",
              margin: "auto",
              borderRadius: "15px",
              padding: "20px",
              background: "#D3D3D380",
            }}
          >
            <h3>{tr("Terms and Conditions")}:</h3>
            {contract?.data.terms.terms_and_conditions ? (
              <div>
                {contract?.data.terms.terms_and_conditions.split(/\n/g).map((line, index) => (
                  <p key={index}>
                    {line === "" ? <br /> : line} {/* Keeps extra empty lines */}
                  </p>
                ))}
              </div>
            ) : null}
            <br/>
            <div className="flex items-center space-x-2">
              <input 
                className="w-5 h-5"
                type="checkbox"
                id="terms"
                name="terms"
                checked={termsChecked}
                onChange={() => {
                  setTermsChecked(!termsChecked);
                }}
              />
              <p className=" font-bold">
                {tr("I have read and agree to the above Terms and Conditions")}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-4 justify-end mt-6">
            <Button onClick={decline}>
              {tr("Decline")}
            </Button>
            <Button
              primary
              onClick={() => {
                if (termsChecked) {
                  signContract.mutate({ action: "approve" });
                } else {
                  alert("Please read and agree to the Terms and Conditions");
                }
              }}
            >
              {tr("Approve")}
            </Button>
          </div>
        </Content>
      </div>
    );
  }
}

const Image = styled.img`
  width: 300px;
  margin: auto;
`;

const Content = styled.div`
  width: 100%;
  align-self: center;
  max-width: 900px;
`;
